import { axios } from '@/lib/axios'
import CrudService from '@/services/crudService'

class DelegationService extends CrudService {
  constructor() {
    super('delegations')
  }

  uploadDelegation = async (file) => {
    const form = new FormData()
    form.append('file', file)

    const response = await axios.post(`${this.resource}/upload`, form)

    return response.data
  }
}

export default DelegationService
